module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchbar":{"placeholder":"Search by company name, candidate\u0027s email or name, case id"}}}')
  delete Component.options._Ctor
}
